var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-container"},[_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.src,"width":_vm.width,"height":_vm.height,"allowfullscreen":_vm.allowfullscreen}})])
}
var staticRenderFns = []

export { render, staticRenderFns }